import { CustomLink } from '@/components/custom-link/CustomLink';
import { GlobalClassName } from '@/shared/constant/GlobalClassName';
import type { SidebarTreeDataSchemaNode } from '@/shared/constant/sidebar-tree/SidebarTreeNode';
import { FoxIconDataModel } from 'aui-biz-icons';
import clsx from 'clsx';
import React from 'react';
import styles from '../../SidebarTree.module.css';
import { useSidebarTreeStore } from '../../store/sidebarTreeStore';
import { generateClassNameBySidebarTreeNodeKey } from '../../util/generateClassNameBySidebarTreeNodeKey';

export type SidebarDataSchemaProps = {
  value: SidebarTreeDataSchemaNode;
};

export const SidebarDataSchema = React.memo(function SidebarDataSchemaComponent(
  props: SidebarDataSchemaProps,
) {
  const { value } = props;
  const { to, resourceName } = props.value;

  const selected = useSidebarTreeStore((x) => x.selectedKey === value.key);
  const setSelectedKey = useSidebarTreeStore((x) => x.setSelectedKey);

  return (
    <li
      className={clsx(GlobalClassName.SidebarItemLink, {
        [GlobalClassName.SidebarItemLinkActive]: selected,
      })}
    >
      <CustomLink
        className={clsx('items-start', styles['sidebar-tree-node'], {
          [`${styles['sidebar-tree-node--selected']}`]: selected,
          ['font-600']: selected,
          [generateClassNameBySidebarTreeNodeKey(value.key)]: selected,
        })}
        sampleName={resourceName}
        to={to}
        title={resourceName}
        onClick={() => {
          setSelectedKey(value.key);
        }}
      >
        <FoxIconDataModel className="mr-2 pt-1 text-purple-6" />
        <span className="break-word">{resourceName}</span>

        <div className="flex-1" />
      </CustomLink>
    </li>
  );
});
